import { Suspense, useEffect, useState } from 'react';
import { RouterProvider } from 'react-router';
import { ConfigProvider } from 'antd';
import zhCN from 'antd/locale/zh_CN';
import enUS from 'antd/locale/en_US';
import dayjs from 'dayjs';
import 'dayjs/locale/zh-cn';
import { useTranslation } from 'react-i18next';
import router from '@/router/index';
import { PageLoading } from '@/components';
import '@/styles/index.less';

const resolveAntdLocale = (lng?: string) => (lng && lng.startsWith('zh') ? zhCN : enUS);

const resolveDayjsLocale = (lng?: string) => (lng && lng.startsWith('zh') ? 'zh-cn' : 'en');

const App = () => {
  const { i18n } = useTranslation();
  const [antdLocale, setAntdLocale] = useState(() => resolveAntdLocale(i18n.language));

  useEffect(() => {
    const handleLanguageChanged = (lng: string) => {
      setAntdLocale(resolveAntdLocale(lng));
      dayjs.locale(resolveDayjsLocale(lng));
    };
    handleLanguageChanged(i18n.language);
    i18n.on('languageChanged', handleLanguageChanged);
    return () => {
      i18n.off('languageChanged', handleLanguageChanged);
    };
  }, [i18n]);

  return (
    <ConfigProvider locale={antdLocale}>
      {/* 顶层兜底 Suspense：覆盖无布局的顶层路由（/review-tasks、/doc-editor 等）的懒加载 */}
      <Suspense fallback={<PageLoading />}>
        <RouterProvider router={router} />
      </Suspense>
    </ConfigProvider>
  );
};

export default App;
